import { mapGetters, mapActions, mapMutations } from 'vuex'
import countries from '@/utils/_countries.json'

export default {
  name: 'SearchConsoleIntegration',
  data () {
    return {
      isLoading: {
        integrations: false,
        save: false,
        delete: false
      },
      settings: [
        { label: 'Property (required)', id: 'gsc_property', value: '', options: [], disabled: false, required: true },
        { label: 'Country filter', id: 'gsc_country', value: '', options: [...countries], disabled: false, required: false },
        { label: 'URL filter INCLUDE (regexp)', id: 'gsc_url_include', value: '', disabled: false, required: false },
        { label: 'URL filter EXCLUDE (regexp)', id: 'gsc_url_exclude', value: '', disabled: false, required: false }
      ],
      permissionError: false,
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters([
      'integrations',
      'searchConsoleIntegration',
      'googleAnalyticsIntegration'
    ]),
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    },
    contentplanId () {
      return parseInt(this.$route.params.contentplanId)
    },
    hasIntegration () {
      return !!this.searchConsoleIntegration?.gsc_property
    }
  },
  methods: {
    ...mapActions([
      'getSearchConsoleProperties',
      'postSearchConsoleIntegration',
      'getIntegrations',
      'sendWebsocketMessage',
      'deleteIntegration'
    ]),
    ...mapMutations([
      'addProgressTracker',
      'setAuthToken',
      'setSnackbar'
    ]),
    async handleConnect () {
      this.isLoading.save = true
      try {
        await this.postSearchConsoleIntegration({
          contentplanId: this.contentplanId,
          property: this.settings[0].value,
          country: this.settings[1].value,
          urlInclude: this.settings[2].value,
          urlExclude: this.settings[3].value
        })
        this.addProgressTracker({
          contentplanId: this.contentplanId,
          name: 'Updating contentplan',
          stepsObject: {
            Importing: 'inProgress',
            'Checking new pages': 'pending',
            'Page matching': 'pending',
            'Crawling pages': 'pending'
          }
        })
        await this.sendWebsocketMessage({
          action: 'runOrchestrator',
          message: {
            contentplanId: this.contentplanId,
            runUpdating: true,
            userType: 'managed'
          }
        })
        this.$router.push({
          name: 'ContentplanSettings',
          params: { contentplanId: this.contentplanId }
        })
      } catch (error) {
        console.error(error)
      }
      this.isLoading.save = false
    },
    async loadSearchConsoleProperties () {
      try {
        const properties = await this.getSearchConsoleProperties()
        this.settings[0].options = properties.map(p => {
          // Check if properties is an array of strings or objects
          return typeof p === 'string' ? p : p.domain
        })
        this.permissionError = false
        this.errorMessage = ''
      } catch (error) {
        console.error('Error loading GSC properties:', error)
        const statusCode = error?.response?.status
        const errorMsg = (error?.response?.data?.message || error.message || '').toLowerCase()
        console.log('Status code:', statusCode)
        console.log('Error message:', errorMsg)

        const isAuthError = statusCode === 401 || statusCode === 403 || errorMsg.includes('token') || errorMsg.includes('auth') || errorMsg.includes('permission') || errorMsg.includes('access denied') || errorMsg.includes('unauthorized') || errorMsg.includes('forbidden') || errorMsg.includes('not found')
        console.log('Is auth error:', isAuthError)

        if (isAuthError) {
          this.permissionError = true
          this.errorMessage = 'You have not allowed access to Google Search Console. Please reauthenticate to grant access.'
          console.log('Permission error flag set to true')
        } else {
          this.errorMessage = errorMsg || 'Failed to load Search Console properties'
        }
      }
    },
    handleReauthenticate () {
      const nextUrl = encodeURIComponent(window.location.href)
      const promptValue = encodeURIComponent('select_account consent')
      const params = `next=${nextUrl}&workspaceId=${this.workspaceId}&scope=search-console&prompt=${promptValue}`
      const authUrl = window.location.origin + '/auth/in?' + params
      console.log('Reauthenticating with URL:', authUrl)
      window.location.href = authUrl
    },
    fillValues () {
      this.settings.forEach(s => {
        const integration = this.searchConsoleIntegration
        if (integration) {
          s.value = integration[s.id]
        }
      })
    },
    async handleDelete () {
      if (!this.hasIntegration || this.isLoading.delete) return
      if (!window.confirm('are you sure you want to remove integration')) return

      this.isLoading.delete = true
      try {
        await this.deleteIntegration({
          contentplanId: this.contentplanId,
          integrationType: 'search-console'
        })
        await this.getIntegrations({ contentplanId: this.contentplanId })
        this.setSnackbar({ open: true, text: 'Integration removed.', type: 'success' })
        this.$router.push({
          name: 'ContentplanSettings',
          params: { contentplanId: this.contentplanId, workspaceId: this.workspaceId }
        })
      } catch (error) {
        this.setSnackbar({ open: true, text: `Error: ${error?.response?.data?.message || error.message || 'Could not remove integration'}`, type: 'error' })
      } finally {
        this.isLoading.delete = false
      }
    }
  },
  async mounted () {
    // Check if we received a new auth token after OAuth flow
    const token = this.$route.query.token
    if (token) {
      console.log('Received new auth token after OAuth, updating session')
      this.setAuthToken(token)
      // Remove token from URL without page reload
      this.$router.replace({
        query: { ...this.$route.query, token: undefined }
      }).catch(() => {})
    }

    this.isLoading.integrations = true
    await this.getIntegrations({ contentplanId: this.contentplanId })
    if (this.searchConsoleIntegration) {
      this.fillValues()
    }
    console.log('this.searchConsoleIntegration', this.searchConsoleIntegration)
    await this.loadSearchConsoleProperties()
    this.isLoading.integrations = false
  }
}
